export const hexToRgba = (hex: string, alpha: number) => {
  let cleanHex = hex.replace("#", "")

  // Shorthand (#RGB) omzetten naar full (#RRGGBB)
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split("")
      .map((ch) => ch + ch)
      .join("")
  }

  const r = parseInt(cleanHex.slice(0, 2), 16)
  const g = parseInt(cleanHex.slice(2, 4), 16)
  const b = parseInt(cleanHex.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/**
 * Darken a hex color by a given percentage
 * Supports #RGB, #RRGGBB
 */
export const darkenColor = (hex: string, percent: number) => {
  let cleanHex = hex.replace("#", "")

  // Shorthand (#RGB) omzetten naar full (#RRGGBB)
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split("")
      .map((ch) => ch + ch)
      .join("")
  }

  const r = parseInt(cleanHex.slice(0, 2), 16)
  const g = parseInt(cleanHex.slice(2, 4), 16)
  const b = parseInt(cleanHex.slice(4, 6), 16)

  const darkenedR = Math.max(0, Math.floor(r * (1 - percent)))
  const darkenedG = Math.max(0, Math.floor(g * (1 - percent)))
  const darkenedB = Math.max(0, Math.floor(b * (1 - percent)))

  return `#${darkenedR.toString(16).padStart(2, "0")}${darkenedG.toString(16).padStart(2, "0")}${darkenedB.toString(16).padStart(2, "0")}`
}
